import type { IHeaderLogo, IHeaderSection } from '@/components/main-header/types'

export const useMainHeaderStore = defineStore('mainHeader', () => {
  // When tabs will be handled on our end, then constans of their values can be stored and manipulated in store
  const activeTab = ref('FLT')
  const activeSection = ref<IHeaderSection | null>(null)
  const isMenuOpen = ref(false)
  const logo = ref<IHeaderLogo | null>(null)

  return {
    activeTab,
    activeSection,
    isMenuOpen,
    logo
  }
})
